// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f32529e2","749":"168afddd","903":"6315f363","959":"3c42f0e2","977":"670b9fab"}[chunkId] + ".chunk.js";
};